(function () {
  // Pasek postepu darmowej dostawy w szufladzie koszyka, plakietka promocyjna,
  // pole kodu rabatowego w szufladzie.
  // Steruje tez otwieraniem szuflady po dodaniu z wlasnego ATC - patrz
  // window.RoutinesKoszyk i nasluch #custom-atc-form.
  //
  // Promocja dostawy: od 49 zl zamiast 109 zl, wazna do konca 18 sierpnia 2026
  // (do 19.08 godz. 00:00 czasu sklepu). Potem plakietki znikaja same.
  var PROG_PL = 10900, PROG_PL_PROMO = 4900, PROG_ZAGRANICA = 40001;
  var KONIEC = { rok: 2026, mies: 8, dzien: 19, godz: 0, min: 0 }; // pierwsza chwila PO promocji
  var PROMO_TXT = 'Darmowa dostawa w Polsce od <strong>49 zł</strong> i <strong>obniżone ceny</strong> — tylko dziś, do północy';

  // Prog podajemy bez groszy (99 zl), kwoty do doplaty juz z groszami.
  function zlProg(gr) {
    var v = gr / 100;
    return (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' zł';
  }
  function zl(gr) { return (gr / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function T() { return window.RoutinesTerminy; }
  function polska() {
    var k = (window.Shopify && window.Shopify.country) || 'PL';
    return String(k).toUpperCase() === 'PL';
  }

  function msDoKonca() {
    if (!T()) return 0;
    var t = T().teraz();
    var teraz = Date.UTC(t.rok, t.mies - 1, t.dzien, t.godz, t.min, new Date().getUTCSeconds());
    var koniec = Date.UTC(KONIEC.rok, KONIEC.mies - 1, KONIEC.dzien, KONIEC.godz, KONIEC.min, 0);
    return koniec - teraz;
  }

  var kotwicaCzasu = null;
  function pozostalo() {
    if (kotwicaCzasu === null) {
      var ms = msDoKonca();
      if (!ms) return 0;
      kotwicaCzasu = Date.now() + ms;
    }
    return kotwicaCzasu - Date.now();
  }

  function promocjaTrwa() { return polska() && pozostalo() > 0; }
  function prog() { return polska() ? (promocjaTrwa() ? PROG_PL_PROMO : PROG_PL) : PROG_ZAGRANICA; }

  function dwa(n) { return n < 10 ? '0' + n : '' + n; }
  function format(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var g = Math.floor(s / 3600); s -= g * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var zegar = dwa(g) + ':' + dwa(m) + ':' + dwa(s);
    if (d > 0) return d + (d === 1 ? ' dzień ' : ' dni ') + zegar;
    return zegar;
  }

  function htmlPlakietki() {
    return '<span class="rcb-promo__tag">PROMOCJA</span>' +
      '<span class="rcb-promo__txt">' + PROMO_TXT +
      '<span class="rcb-promo__zegar">Kończy się za <strong data-rcb-zegar>' + format(pozostalo()) + '</strong></span>' +
      '</span>';
  }

  function styl() {
    if (document.getElementById('rcb-style')) return;
    var s = document.createElement('style');
    s.id = 'rcb-style';
    s.textContent =
      '.rcb{padding:12px 20px 8px}' +
      '.rcb__msg{font-size:12.5px;font-weight:600;color:#000;margin:0 0 7px}' +
      '.rcb__msg strong{font-weight:700}' +
      '.rcb__msg--ok{color:#2e7d4f}' +
      '.rcb__track{height:6px;border-radius:999px;background:#ece7dc;overflow:hidden}' +
      '.rcb__fill{height:100%;border-radius:999px;background:#000;transition:width .35s ease}' +
      '.rcb--ok .rcb__fill{background:#2e9e5b}' +
      '.rcb-promo{display:flex;align-items:flex-start;gap:8px;background:#f3fbe0;border:1px solid #d7ecb0;border-radius:8px;padding:8px 10px;margin:0 0 10px;font-family:Barlow,var(--font-body-family,sans-serif)}' +
      '.rcb-promo__tag{flex-shrink:0;background:#000;color:#baff46;font-size:10.5px;font-weight:700;letter-spacing:.7px;padding:4px 8px;border-radius:3px;line-height:1.35}' +
      '.rcb-promo__txt{font-size:13px;line-height:1.45;color:#33401d}' +
      '.rcb-promo__txt strong{color:#000;font-weight:700}' +
      '.rcb-promo__zegar{display:block;margin-top:5px;font-size:13px;color:#5a6b3a}' +
      '.rcb-promo__zegar strong{font-size:16px;font-weight:800;color:#000;font-variant-numeric:tabular-nums;font-feature-settings:"tnum";letter-spacing:.5px}' +
      '.rcb-promo--pdp{margin:14px 0 2px}' +
      '.rcb-promo--cart{max-width:760px;margin:0 auto 18px}' +
      '.rcb-kod{margin:0 0 12px;font-family:Barlow,var(--font-body-family,sans-serif)}' +
      '.rcb-kod__link{background:none;border:none;padding:0;font-family:inherit;font-size:15px;font-weight:700;color:#000;text-decoration:underline;text-underline-offset:2px;cursor:pointer}' +
      '.rcb-kod__link:hover{color:#444}' +
      '.rcb-kod__form{display:flex;gap:6px;margin-top:9px}' +
      '.rcb-kod__input{flex:1;min-width:0;height:40px;border:1px solid #d8d3c7;border-radius:6px;padding:0 11px;font-family:inherit;font-size:14px;color:#000;background:#fff;text-transform:uppercase}' +
      '.rcb-kod__input:focus{outline:none;border-color:#000}' +
      '.rcb-kod__btn{flex-shrink:0;height:40px;border:none;border-radius:6px;background:#000;color:#fff;font-family:inherit;font-size:11.5px;font-weight:700;letter-spacing:.6px;padding:0 15px;cursor:pointer}' +
      '.rcb-kod__btn:disabled{opacity:.6;cursor:default}' +
      '.rcb-kod__msg{margin:7px 0 0;font-size:12.5px;line-height:1.4}' +
      '.rcb-kod__msg--ok{color:#2e7d4f}' +
      '.rcb-kod__msg--blad{color:#c0392b}' +
      '.rcb-kod__lista{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}' +
      '.rcb-kod__lista:empty{margin-top:0}' +
      '.rcb-kod__pill{display:inline-flex;align-items:center;gap:6px;background:#f2faf4;border:1px solid #bfe3cb;border-radius:999px;padding:4px 7px 4px 11px;font-size:12.5px;font-weight:700;color:#2e7d4f}' +
      '.rcb-kod__usun{background:none;border:none;padding:0;width:15px;height:15px;line-height:1;cursor:pointer;color:#2e7d4f;font-size:15px}';
    document.head.appendChild(s);
  }

  var zapisHTML = null, zapisKlasa = 'rcb';

  function budujHTML() {
    var html = '';
    if (promocjaTrwa()) html += '<div class="rcb-promo">' + htmlPlakietki() + '</div>';
    html += '<p class="rcb__msg"></p><div class="rcb__track"><div class="rcb__fill" style="width:0%"></div></div>';
    return html;
  }

  function pasek() {
    var el = document.getElementById('rcb-bar');
    if (!el) {
      el = document.createElement('div');
      el.id = 'rcb-bar';
      el.className = zapisKlasa;
      el.innerHTML = zapisHTML || budujHTML();
    }
    return el;
  }

  function osadz() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return null;
    var wrap = drawer.querySelector('.hdt-mini-cart__wrap');
    if (!wrap) return null;
    var el = pasek();
    if (el.parentNode !== drawer || el.nextSibling !== wrap) drawer.insertBefore(el, wrap);
    return el;
  }

  function zapamietaj(el) { zapisHTML = el.innerHTML; zapisKlasa = el.className; }

  function etykietaKasy(c) {
    var span = document.querySelector('#CartDrawer .hdt-mini-cart__btn-checkout span');
    if (!span) return;
    var txt = 'PRZEJDŹ DO KASY • ' + zl(c.total_price);
    if (span.textContent !== txt) span.textContent = txt;
  }

  function infoWysylki() {
    var bottom = document.querySelector('#CartDrawer .hdt-mini-cart__bottom-wrap');
    if (!bottom || !T()) return;
    var el = bottom.querySelector('.rcb-ship');
    if (!el) {
      el = document.createElement('p');
      el.className = 'rcb-ship';
      bottom.appendChild(el);
    }
    var html = T().tekstSzuflada();
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  function odswiezPasek() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        etykietaKasy(c); infoWysylki(); strzalki(); wskaznikPrzewijania();
        polePromo(c);
        var el = osadz();
        if (!el) return;
        if (!c.item_count) { el.style.display = 'none'; return; }
        el.style.display = '';

        var maPromo = !!el.querySelector('.rcb-promo');
        if (maPromo !== promocjaTrwa()) el.innerHTML = budujHTML();

        var limit = prog(), suma = 0;
        (c.items || []).forEach(function (i) { if (i.requires_shipping) suma += i.final_line_price; });
        suma -= c.total_discount || 0;
        if (suma < 0) suma = 0;

        var udzial = Math.min(1, suma / limit);
        var msg = el.querySelector('.rcb__msg'), fill = el.querySelector('.rcb__fill');
        var szer = (udzial * 100).toFixed(1) + '%';
        if (fill.style.width !== szer) fill.style.width = szer;

        var html;
        if (udzial >= 1) {
          el.classList.add('rcb--ok'); msg.classList.add('rcb__msg--ok');
          html = 'Masz <strong>dostawę GRATIS</strong>';
        } else {
          el.classList.remove('rcb--ok'); msg.classList.remove('rcb__msg--ok');
          html = 'Do <strong>darmowej dostawy</strong> brakuje Ci <strong>' + zl(limit - suma) + '</strong>';
        }
        if (msg.innerHTML !== html) msg.innerHTML = html;
        zapamietaj(el);
      })
      .catch(function () {});
  }

  function plakietkaGdzieIndziej() {
    if (!promocjaTrwa()) return;
    var kotwicaPdp = document.querySelector('.custom-atc-wrapper') ||
                     document.querySelector('.express-checkout-wrapper');
    if (kotwicaPdp && kotwicaPdp.parentNode && !document.querySelector('.rcb-promo--pdp')) {
      var p = document.createElement('div');
      p.className = 'rcb-promo rcb-promo--pdp';
      p.innerHTML = htmlPlakietki();
      kotwicaPdp.parentNode.insertBefore(p, kotwicaPdp);
    }
    if (window.location.pathname.indexOf('/cart') === 0 && !document.querySelector('.rcb-promo--cart')) {
      var kotwicaCart = document.querySelector('.hdt-main-cart, form[action$="/cart"], main .hdt-container');
      if (kotwicaCart && kotwicaCart.parentNode) {
        var c = document.createElement('div');
        c.className = 'rcb-promo rcb-promo--cart';
        c.innerHTML = htmlPlakietki();
        kotwicaCart.parentNode.insertBefore(c, kotwicaCart);
      }
    }
  }

  var zegarInt = null;
  function tykaj() {
    var ms = pozostalo();
    if (ms <= 0) {
      Array.prototype.forEach.call(document.querySelectorAll('.rcb-promo'), function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      if (zegarInt) { clearInterval(zegarInt); zegarInt = null; }
      odswiezPasek();
      return;
    }
    var txt = format(ms);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rcb-zegar]'), function (el) {
      if (el.textContent !== txt) el.textContent = txt;
    });
  }
  function startZegara() {
    if (zegarInt || !promocjaTrwa()) return;
    tykaj();
    zegarInt = setInterval(tykaj, 1000);
  }

  // ---- Kod rabatowy w szufladzie --------------------------------------------
  // Shopify nie udokumentowal metody AJAX na kody, ale /cart/update.js przyjmuje
  // pole discount i zwraca cart.discount_codes z flaga applicable. Tego wlasnie
  // potrzebuje AOV.ai: kod wpisany w koszyku uruchamia dorzucenie prezentu, ktory
  // pojawia sie jako osobna pozycja za 0 zl - ale dopiero chwile po odpowiedzi.
  var KODY_UKRYTE = /^AOV/i;  // techniczne kody aplikacji, klientowi nic nie mowia

  function widoczneKody(c) {
    return ((c && c.discount_codes) || []).filter(function (k) {
      return k.applicable && !KODY_UKRYTE.test(k.code);
    });
  }

  function komunikatKodu(tekst, rodzaj) {
    var el = document.querySelector('[data-rcb-kod-msg]');
    if (!el) return;
    el.textContent = tekst || '';
    el.className = 'rcb-kod__msg' + (rodzaj ? ' rcb-kod__msg--' + rodzaj : '');
    el.hidden = !tekst;
  }

  function rysujKody(c) {
    var lista = document.querySelector('[data-rcb-kod-lista]');
    if (!lista) return;
    var html = widoczneKody(c).map(function (k) {
      return '<span class="rcb-kod__pill">' + k.code +
             ' <button type="button" class="rcb-kod__usun" data-rcb-kod-usun="' + k.code +
             '" aria-label="Usuń kod ' + k.code + '">&times;</button></span>';
    }).join('');
    if (lista.innerHTML !== html) lista.innerHTML = html;
  }

  function polePromo(c) {
    var bottom = document.querySelector('#CartDrawer .hdt-mini-cart__bottom-wrap');
    if (!bottom) return;
    var box = bottom.querySelector('.rcb-kod');
    if (!box) {
      box = document.createElement('div');
      box.className = 'rcb-kod';
      box.innerHTML =
        '<button type="button" class="rcb-kod__link" data-rcb-kod-toggle>Masz kod rabatowy?</button>' +
        '<div class="rcb-kod__form" hidden data-rcb-kod-form>' +
          '<input type="text" class="rcb-kod__input" placeholder="Wpisz kod" autocomplete="off" spellcheck="false" data-rcb-kod-input>' +
          '<button type="button" class="rcb-kod__btn" data-rcb-kod-apply>ZASTOSUJ</button>' +
        '</div>' +
        '<p class="rcb-kod__msg" hidden data-rcb-kod-msg></p>' +
        '<div class="rcb-kod__lista" data-rcb-kod-lista></div>';
      bottom.insertBefore(box, bottom.firstChild);
    }
    rysujKody(c);
  }

  function ustawKod(kod) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: kod })
    }).then(function (r) { return r.json(); });
  }

  function zastosujKod() {
    var input = document.querySelector('[data-rcb-kod-input]');
    var btn = document.querySelector('[data-rcb-kod-apply]');
    if (!input) return;
    var kod = (input.value || '').trim();
    if (!kod) { input.focus(); return; }

    if (btn) { btn.disabled = true; btn.textContent = 'SPRAWDZAM…'; }
    komunikatKodu('', null);

    // Shopify trzyma tylko jeden kod naraz, a odrzucony i tak zajmuje miejsce.
    // Zapamietujemy wiec aktywny i po nieudanej probie wracamy do niego - inaczej
    // jedna literowka blokowalaby kolejna, poprawna probe.
    var poprzedni = null;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var akt = widoczneKody(c)[0];
        poprzedni = akt ? akt.code : null;
        return ustawKod(kod);
      })
      // prezent z AOV dolatuje chwile po odpowiedzi - dajemy mu czas
      .then(function () { return new Promise(function (r) { setTimeout(r, 1300); }); })
      .then(function () { return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        var szukany = kod.toUpperCase();
        var wpis = null;
        (c.discount_codes || []).forEach(function (k) {
          if (String(k.code).toUpperCase() === szukany) wpis = k;
        });
        if (wpis && wpis.applicable) {
          input.value = '';
          // komunikat dopiero PO przebudowie szuflady - inaczej zniknalby razem
          // ze starym DOM-em dolnej sekcji
          return odswiezSzuflade()
            .then(function () { return odswiezPasek(); })
            .then(function () { komunikatKodu('Kod ' + wpis.code + ' aktywowany.', 'ok'); });
        }
        // Shopify dopisuje do listy takze kody nieistniejace (applicable: false),
        // wiec nie da sie odroznic literowki od niespelnionych warunkow.
        return ustawKod(poprzedni || '')
          .then(function () { return odswiezPasek(); })
          .then(function () { komunikatKodu('Kod ' + kod + ' nie działa w tym koszyku.', 'blad'); });
      })
      .catch(function () { komunikatKodu('Coś poszło nie tak. Spróbuj jeszcze raz.', 'blad'); })
      .then(function () {
        var b = document.querySelector('[data-rcb-kod-apply]');
        if (b) { b.disabled = false; b.textContent = 'ZASTOSUJ'; }
        var f = document.querySelector('[data-rcb-kod-form]');
        if (f) f.hidden = false;
      });
  }

  // Zdejmowanie kodu obsluguje routines-kod-sprzatanie.js - musi tez usunac
  // prezent, ktory po utracie kodu przestaje byc darmowy.
  function usunKody() {
    return ustawKod('')
      .then(function () { return new Promise(function (r) { setTimeout(r, 900); }); })
      .then(function () { return odswiezSzuflade(); })
      .then(function () { odswiezPasek(); komunikatKodu('', null); });
  }

  // Otwarcie szuflady natywna sciezka motywu: Ecomus nasluchuje klikniec w elementy
  // z aria-controls="CartDrawer" i sam ustawia open/open-dialog, no-scroll oraz
  // pulapke focusu. Atrybuty ustawiamy recznie tylko jako zapas.
  function otworzSzuflade() {
    var d = document.getElementById('CartDrawer');
    if (!d || d.hasAttribute('open')) return;
    var kotwica = document.querySelector('[aria-controls="CartDrawer"]');
    if (kotwica) { kotwica.click(); return; }
    d.setAttribute('open', '');
    d.setAttribute('open-dialog', '');
    document.documentElement.classList.add('no-scroll');
    stanSzuflady();
  }

  // Zamek: karta moze poprosic o pokazanie koszyka dwa razy (wlasny skrypt ATC
  // i nasluch cart:updated). Bez niego szuflada odswiezalaby sie dwukrotnie.
  var trwaPokaz = false;
  function odswiezIOtworz() {
    if (trwaPokaz) return Promise.resolve();
    trwaPokaz = true;
    return odswiezSzuflade().then(function () {
      odswiezPasek();
      otworzSzuflade();
      // Stare kopie ATC w szablonach emituja cart:refresh, na co motyw przeladowuje
      // sekcje szuflady i kasuje jej stan otwarcia - zmierzone: otwarcie w 2191 ms,
      // zamkniecie w 2406 ms. Ponawiamy wiec probe, gdy motyw juz skonczy.
      setTimeout(otworzSzuflade, 500);
      setTimeout(otworzSzuflade, 1100);
      setTimeout(function () { trwaPokaz = false; }, 1400);
    });
  }

  window.RoutinesKoszyk = {
    odswiez: odswiezSzuflade,
    otworz: otworzSzuflade,
    odswiezIOtworz: odswiezIOtworz
  };

  function tor() { return document.querySelector('#CartDrawer .rcd-carousel__track'); }

  function strzalki() {
    var track = tor(), nav = document.querySelectorAll('#CartDrawer .rcd-nav');
    if (!track || !nav.length || !track.clientWidth) return;
    var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
    nav.forEach(function (b) {
      var kier = parseInt(b.getAttribute('data-rcd-scroll'), 10);
      var stop = max <= 2 || (kier < 0 && x <= 2) || (kier > 0 && x >= max - 2);
      if (stop) b.setAttribute('disabled', ''); else b.removeAttribute('disabled');
    });
  }

  function wskaznikPrzewijania() {
    var s = document.querySelector('#CartDrawer .hdt-mini-cart__sroll');
    if (!s) return;
    var jest = s.scrollHeight - s.clientHeight > 8 && s.scrollTop < s.scrollHeight - s.clientHeight - 8;
    s.classList.toggle('rcb-more', jest);
  }

  function przeliczPoOtwarciu() {
    strzalki(); wskaznikPrzewijania();
    setTimeout(function () { strzalki(); wskaznikPrzewijania(); }, 120);
    setTimeout(function () { strzalki(); wskaznikPrzewijania(); }, 400);
  }

  function przewin(btn) {
    var kar = btn.closest('.rcd-carousel');
    var track = kar ? kar.querySelector('.rcd-carousel__track') : null;
    if (!track) return;
    var karta = track.querySelector('.rcd-card');
    var krok = karta ? (karta.getBoundingClientRect().width + 10) * 2 : 280;
    var kier = parseInt(btn.getAttribute('data-rcd-scroll'), 10);
    var max = track.scrollWidth - track.clientWidth;
    var cel = track.scrollLeft + krok * kier;
    if (cel < 0) cel = 0;
    if (cel > max) cel = max;
    track.scrollLeft = cel;
    setTimeout(strzalki, 60);
    setTimeout(strzalki, 450);
  }

  function odswiezSzuflade() {
    var stary = document.getElementById('CartDrawer');
    if (!stary) return Promise.resolve();
    var sid = stary.getAttribute('section-id') || 'cart-drawer';
    return fetch(window.Shopify.routes.root + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d[sid];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nowy = tmp.querySelector('#CartDrawer');
        if (!nowy) return;
        var byloOtwarte = stary.hasAttribute('open') || stary.hasAttribute('open-dialog');
        var pasekEl = document.getElementById('rcb-bar');
        if (pasekEl) {
          zapamietaj(pasekEl);
          if (pasekEl.parentNode) pasekEl.parentNode.removeChild(pasekEl);
        }
        stary.innerHTML = nowy.innerHTML;
        if (byloOtwarte) { stary.setAttribute('open', ''); stary.setAttribute('open-dialog', ''); }
        osadz(); stanSzuflady(); przeliczPoOtwarciu();
      })
      .catch(function () {});
  }

  function dodaj(btn) {
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-rcd-add'), 10);
    if (!id) return;
    btn.disabled = true;
    var org = btn.textContent;
    btn.textContent = 'DODAJĘ…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (koszyk) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: koszyk } }));
        return odswiezSzuflade();
      })
      .then(odswiezPasek)
      .catch(function () { btn.disabled = false; btn.textContent = org; });
  }

  function stanSzuflady() {
    var d = document.getElementById('CartDrawer');
    var otwarta = !!d && (d.hasAttribute('open') || d.hasAttribute('open-dialog'));
    document.body.classList.toggle('rcd-drawer-open', otwarta);
    if (otwarta) przeliczPoOtwarciu();
  }

  var timer = null;
  function zaplanuj() { clearTimeout(timer); timer = setTimeout(odswiezPasek, 200); }

  function start() {
    styl();
    plakietkaGdzieIndziej();
    startZegara();
    // RoutinesTerminy moze doladowac sie chwile pozniej - probujemy jeszcze raz
    setTimeout(function () { plakietkaGdzieIndziej(); startZegara(); }, 700);

    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    stanSzuflady();
    odswiezPasek();

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var add = e.target.closest('[data-rcd-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); dodaj(add); return; }
      var nav = e.target.closest('[data-rcd-scroll]');
      if (nav) { e.preventDefault(); e.stopPropagation(); przewin(nav); return; }

      if (e.target.closest('[data-rcb-kod-toggle]')) {
        e.preventDefault();
        var form = document.querySelector('[data-rcb-kod-form]');
        if (form) {
          form.hidden = !form.hidden;
          if (!form.hidden) { var pole = form.querySelector('[data-rcb-kod-input]'); if (pole) pole.focus(); }
        }
        return;
      }
      if (e.target.closest('[data-rcb-kod-apply]')) { e.preventDefault(); zastosujKod(); return; }
      var usun = e.target.closest('[data-rcb-kod-usun]');
      if (usun) { e.preventDefault(); usunKody(); return; }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (!e.target || !e.target.matches || !e.target.matches('[data-rcb-kod-input]')) return;
      e.preventDefault();
      zastosujKod();
    });

    document.addEventListener('scroll', function (e) {
      if (!e.target || !e.target.classList) return;
      if (e.target.classList.contains('rcd-carousel__track')) strzalki();
      if (e.target.classList.contains('hdt-mini-cart__sroll')) wskaznikPrzewijania();
    }, true);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { strzalki(); wskaznikPrzewijania(); });
      var pilnuj = function () {
        var t = tor();
        if (t && t !== pilnuj._t) {
          if (pilnuj._t) ro.unobserve(pilnuj._t);
          ro.observe(t);
          pilnuj._t = t;
        }
      };
      pilnuj();
      drawer.addEventListener('transitionend', pilnuj);
      setInterval(pilnuj, 1500);
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && (t.closest('#rcb-bar') || t.closest('.hdt-mini-cart__btn-checkout') ||
            t.closest('.rcb-ship') || t.closest('.rcd-nav') || t.closest('.rcb-kod'))) continue;
        osadz(); zaplanuj();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });

    new MutationObserver(stanSzuflady).observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'open-dialog'] });

    // Karty produktow dodaja do koszyka na dwa sposoby: przez snippet routines-atc
    // oraz przez starsze kopie tego samego formularza wklejone w Custom Liquid.
    // Wspolnym mianownikiem jest #custom-atc-form - lapiemy jego submit i dopiero po
    // odpowiedzi serwera (cart:updated) pokazujemy szuflade. Pozostale zmiany koszyka
    // (ilosc, usuwanie, rekomendacje w szufladzie) tylko przeliczaja pasek.
    var czekaNaPokaz = false;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      // UWAGA: nie f.id - formularz ma pole <input name="id">, a nazwane pola
      // przeslaniaja wlasciwosci formularza, wiec f.id zwraca ten input, nie string.
      if (f && f.getAttribute && f.getAttribute('id') === 'custom-atc-form') czekaNaPokaz = true;
    }, true);

    document.addEventListener('cart:updated', function () {
      if (!czekaNaPokaz) { zaplanuj(); return; }
      czekaNaPokaz = false;
      odswiezIOtworz();
    });
    document.addEventListener('routines:cart-added', function () { odswiezIOtworz(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
